const divLogin = {
  showError: 'Erro na requisição, se persistir, contate o suporte',
  showErrorConnection: 'Error de conexión',
  showErrorManyRequests: 'Demasiados intentos seguidos, vuelve a intentarlo en un momento',
  showErrorPassword: 'Usuario o contraseña incorrectos',

  noAccess: 'No tiene autorización, hable con su administrador'
};

export default divLogin;
